"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoPanel = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.reduce.js");
var _react = _interopRequireWildcard(require("react"));
var _List = _interopRequireDefault(require("@mui/material/List"));
var _material = require("@mui/material");
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../utils/constants");
var _LegendItem = require("./LegendItem");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  ComponentTypes
} = _paulCorePackage.constants;

/** @todo remove translation key numbers */
const InfoPanel = exports.InfoPanel = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    unChecked = [],
    setUnChecked,
    setHoverLine,
    equipmentKey,
    data
  } = _ref;
  const tActiveV = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsValues);
  const equipmentKeyIsPwh = equipmentKey === _constants.keysForGroupChartsById.Pwh;
  const TypePipe = equipmentKeyIsPwh ? ComponentTypes.PwhPipe : ComponentTypes.HtgPipe;
  const handleToggle = (0, _react.useCallback)(item => {
    const currentIndex = unChecked.findIndex(unCheck => unCheck.id === item.id);
    const newChecked = [...unChecked];
    if (currentIndex === -1) {
      newChecked.push(item);
    } else newChecked.splice(currentIndex, 1);
    setUnChecked(newChecked);
  }, [setUnChecked, unChecked]);
  const legend = (0, _react.useMemo)(() => data.reduce((acc, item) => {
    var _tActiveV$Default, _tActiveV$item$equipm;
    if (item.equipmentType === TypePipe && acc.find(device => device.equipmentType === item.equipmentType) || acc.find(device => device.equipmentType === item.equipmentType && device.displayNameId === item.displayNameId)) return acc;
    const title = "".concat((tActiveV === null || tActiveV === void 0 || (_tActiveV$Default = tActiveV.Default) === null || _tActiveV$Default === void 0 ? void 0 : _tActiveV$Default.equipmentType[item.equipmentType]) || item.equipmentType, " - ").concat(((_tActiveV$item$equipm = tActiveV[item.equipmentType]) === null || _tActiveV$item$equipm === void 0 ? void 0 : _tActiveV$item$equipm.displayNameId[item.displayNameId]) || '');
    return [...acc, {
      id: item.id,
      equipmentType: item.equipmentType,
      title,
      displayNameId: item.displayNameId,
      icon: item.icon
    }];
  }, []), [data, TypePipe, tActiveV]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    px: 2,
    container: true,
    rowSpacing: 1,
    columnSpacing: {
      xs: 2,
      sm: 4,
      md: 10
    },
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 6,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(_List.default, {
    dense: true,
    sx: {
      width: '100%',
      maxWidth: 720
    }
  }, legend.map(item => /*#__PURE__*/_react.default.createElement(_LegendItem.LegendItem, {
    onMouseEnter: () => setHoverLine(item),
    onMouseLeave: () => setHoverLine(null),
    key: item.id,
    checked: !unChecked.find(unCheck => unCheck.id === item.id),
    onCheck: () => handleToggle(item),
    item: item
  })))));
}, (prev, next) => _paulCorePackage.functions.areEqual(prev.unChecked, next.unChecked) && prev.setUnChecked === next.setUnChecked && prev.setHoverLine === next.setHoverLine && prev.equipmentKey === next.equipmentKey && _paulCorePackage.functions.areEqual(prev.data, next.data));
InfoPanel.propTypes = {
  unChecked: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string
  })),
  setUnChecked: _propTypes.default.func,
  setHoverLine: _propTypes.default.func,
  equipmentKey: _propTypes.default.string,
  data: _propTypes.default.arrayOf(_propTypes.default.shape({})) // device[]
};